type LoadingPhase = "exploring" | "evaluating" | "awaiting_track";

type Props = {
  phase: LoadingPhase;
};

export default function LoadingOpenIssuesList({ phase }: Props) {
  const exploring = phase === "exploring";
  const awaitingTrack = phase === "awaiting_track";

  return (
    <section className="dashboard-section">
      <div className="dashboard-section-body">
        <div className="mb-1">
          <h2 className="text-xl font-semibold text-gray-900">Open issues</h2>
          <p className="text-sm text-gray-500">
            {exploring
              ? "Waiting for page discovery to finish"
              : awaitingTrack
                ? "Issues appear after you choose pages to evaluate"
                : "Issues appear here as pages finish evaluating"}
          </p>
        </div>

        <div className="mt-6 space-y-3">
          {awaitingTrack ? (
            <EmptyHint text="No issues yet. Select pages to evaluate to start evaluation." />
          ) : (
            <>
              <SkeletonIssueRow />
              <SkeletonIssueRow />
              <SkeletonIssueRow />
              {exploring ? null : (
                <EmptyHint text="More issues may appear as remaining pages finish. This usually takes a few minutes." />
              )}
            </>
          )}
        </div>
      </div>
    </section>
  );
}

function SkeletonIssueRow() {
  return (
    <div className="rounded-lg border border-gray-200 bg-white px-4 py-4">
      <div className="mb-3 flex items-center gap-2">
        <div className="h-5 w-14 animate-pulse rounded-md bg-gray-200" />
        <div className="h-3 w-36 animate-pulse rounded bg-gray-100" />
      </div>
      <div className="h-4 w-3/4 max-w-xl animate-pulse rounded bg-gray-200" />
      <div className="mt-2 h-3 w-48 animate-pulse rounded bg-gray-100" />
    </div>
  );
}

function EmptyHint({ text }: { text: string }) {
  return (
    <p className="rounded-lg border border-dashed border-gray-200 px-4 py-6 text-center text-sm text-gray-500">
      {text}
    </p>
  );
}
